/**
 * Adds event listeners and functionality to the product page when the DOM is loaded.
 * NOTE: using replace function on strings (as was in process_xml()) does weird things on gLightbox css...
 */
document.addEventListener('DOMContentLoaded', function() {
    const language = document.querySelector('html').getAttribute('lang') === 'fr' ? 'french' : 'english';
    const email_value = getCookieValue('mail');

    const pdrButton = document.querySelector('#pdr_c');
    if (pdrButton) {
        pdrButton.addEventListener('click', function(event) {
            op_pdr(event, email_value);
        });
    }

    const quButton = document.querySelector('#qu_c');
    if (quButton) {
        quButton.addEventListener('click', function(event) {
            op_qu(event, email_value);
        });
    }

    const quantityInputs = document.querySelectorAll('.quantity');
    quantityInputs.forEach(function(input) {
        input.addEventListener('change', function(event) {
            let value = parseInt(event.target.value, 10) || 0;
            value = Math.min(Math.max(value, 1), 100);
            event.target.value = value;
            const updateButton = document.querySelector('input[name=update]');
            if (updateButton) {
                updateButton.click();
            }
        });
    });

    const productSubmitForms = document.querySelectorAll('.product_submit');
    productSubmitForms.forEach(function(form) {
        form.addEventListener('submit', function() {
            const reqsigInput = form.querySelector('.reqsig');
            if (reqsigInput) {
                reqsigInput.value = btoa(Date.now().toString());
            }
        });
    });

    /**
     * Retrieves the value of a cookie by its name.
     * @param {string} name - The name of the cookie.
     * @returns {string} The value of the cookie, or an empty string if the cookie doesn't exist.
     */
    function getCookieValue(name) {
        const value = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
        return value ? value.pop() : '';
    }

    /**
     * Opens a question box for the user to ask a question about a product.
     *
     * @param {Event} event - The event that triggered the function.
     * @param {string} email - The user's email address to pre-fill in the email input field.
     */
    function op_qu(event, email) {
        const quBox = document.querySelector('#qu_box');
        quBox.innerHTML = `
            <div id="qu_bc">
                <img id="qu_cancel" src="/v5_test_images/signs/cancel.png" style="float:right">
                <div style="margin-top:3px;float:left;font-weight:bold;">
                    ${language === 'french' ? 'Posez une question sur ce produit :' : 'Ask a question on this product'}
                </div>
                <br class="clear">
                <div id="qu_form">
                    <textarea id="qu_text">${language === 'french' ? 'Votre question :' : 'Your question:'}</textarea>
                    <br class="clear" />
                    <div style="float:left;margin-top:8px;">
                        ${language === 'french' ? 'Votre email :' : 'Your email:'}
                    </div>
                    <input type="text" id="qu_email">
                </div>
                <div id="qu_valid">${language === 'french' ? 'Valider' : 'Validate'}</div>
                <br class="clear">
            </div>
        `;
        const quEmailInput = document.querySelector('#qu_email');
        if (email !== '') {
            quEmailInput.value = email;
        }
        const quTextInput = document.querySelector('#qu_text');
        quTextInput.select();
        quTextInput.focus();
        const quValidButton = document.querySelector('#qu_valid');
        quValidButton.addEventListener('click', function() {
            p_qu(quEmailInput.value, quTextInput.value);
        });
        const quCancelButton = document.querySelector('#qu_cancel');
        quCancelButton.addEventListener('click', function() {
            cancel_qu_request();
        });
        c_pdr();
    }

    /**
     * Opens the product detail request (PDR) box and sets up the form for the user to receive the product page via email.
     *
     * @param {Event} event - The event that triggered the function.
     * @param {string} email - The email address to pre-fill in the email input field.
     */
    function op_pdr(event, email) {
        const pdrBox = document.querySelector('#pdr_b');
        pdrBox.innerHTML = `
            <div id="pdr_bc">
                <img id="pdr_cancel" src="/v5_test_images/signs/cancel.png" style="float:right">
                <div style="margin-top:3px;float:left;font-weight:bold;">
                    ${language === 'french' ? 'Recevoir cette fiche produit par mail :' : 'Receive this product page on your mail:'}
                </div>
                <br class="clear">
                <div style="margin:10px 0px 5px 0px;" id="pdr_form">
                    <div style="float:left;margin-top:3px;">
                        ${language === 'french' ? 'Votre email :' : 'Your email:'}
                    </div>
                    <input type="text" id="pdr_e">
                </div>
                <div id="pdr_v">${language === 'french' ? 'Valider' : 'Validate'}</div>
                <br class="clear"/>
            </div>
        `;
        const pdrEmailInput = document.querySelector('#pdr_e');
        if (email !== '') {
            pdrEmailInput.value = email;
        }
        pdrEmailInput.select();
        pdrEmailInput.focus();
        const pdrValidButton = document.querySelector('#pdr_v');
        pdrValidButton.addEventListener('click', function() {
            p_pdr(pdrEmailInput.value);
        });
        const pdrCancelButton = document.querySelector('#pdr_cancel');
        pdrCancelButton.addEventListener('click', function() {
            c_pdr();
        });
        cancel_qu_request();
    }

    /**
     * Process the email and text to perform a specific action.
     *
     * @param {string} email - The email address.
     * @param {string} text - The text to process.
     * @returns {void}
     */
    function p_qu(email, text) {
        if (IVE(email)) {
            process_xml(email, text);
            cancel_qu_request();
            alert(language === 'french' ? 'Votre demande est enregistrée!' : 'Your request is being processed!');
        } else {
            alert(language === 'french' ? 'Merci d\'entrer une adresse valide' : 'Please enter a valid email address');
            const quEmailInput = document.querySelector('#qu_email');
            quEmailInput.select();
            quEmailInput.focus();
        }
    }

    /**
     * Process the email and perform necessary actions.
     * @param {string} email - The email address to process.
     */
    function p_pdr(email) {
        if (IVE(email)) {
            process_xml(email, 'pdr-');
            c_pdr();
            alert(language === 'french' ? 'Votre demande est enregistrée!' : 'Your request is being processed!');
        } else {
            alert(language === 'french' ? 'Merci d\'entrer une adresse valide' : 'Please enter a valid email address');
            const pdrEmailInput = document.querySelector('#pdr_e');
            pdrEmailInput.select();
            pdrEmailInput.focus();
        }
    }

    /**
     * Processes an XML request by sending an XMLHttpRequest.
     * @param {string} email - The user's email address.
     * @param {string} text - The user's question or "pdr-" for a "Recevoir cette fiche produit par mail" request.
     */
    function process_xml(email, text) {
        const textUrl = encodeURIComponent(text);
        const textEmail = encodeURIComponent(email);
        const thisUrl = window.location;
        document.cookie = `mail=${email}`;
        const xhr = new XMLHttpRequest();
        xhr.open('GET', `/v5_php_modules/v5_qu_request/index.php?email=${textEmail}&question=${textUrl}&lang=${language}&url=${thisUrl}`);
        xhr.send();
    }

    /**
     * Checks if an email address is valid.
     * @param {string} email - The email address to check.
     * @returns {boolean} True if the email address is valid, false otherwise.
     */
    function IVE(email) {
        const filter = /^[\w.+-]+@[\w-]+\.[a-zA-Z]+$/;
        return filter.test(email);
    }

    /**
     * Clears the content of the pdrBox element.
     */
    function c_pdr() {
        const pdrBox = document.querySelector('#pdr_b');
        pdrBox.innerHTML = '';
    }

    /**
     * Cancels the QU request by clearing the content of the QU box.
     */
    function cancel_qu_request() {
        const quBox = document.querySelector('#qu_box');
        quBox.innerHTML = '';
    }
});
